import {
  GET_ALL_BRANDS,
  GET_ALL_SIZES
} from '../constants';

const initialState = {
  brands: [],
  sizes: {
    maleSizes: {
      data: [],
      noDuplicate: [],
    },
    femaleSizes: {
      data: [],
      noDuplicate: []
    },
    kidsSizes: [],
    apparelsSizes: []
  }
}

const handleGetAllBrands = (state, payload) => {
  return {
    ...state, brands: payload.data
  }
}

const handleGetAllSizes = (state, payload) => {
  const { data } = payload;
  let cewek = [];
  let cowok = [];
  let kids = [];
  let apparels = [];

  const groupingSize = data.map((item, index) => {
    if (item.sex === 'M') {
      cowok.push(item)
    } else if (item.sex === 'F') {
      cewek.push(item)
    } else if (!item.sex) {
      apparels.push(item);
    } else if (item.sex == "GS" || item.sex == "K" || item.sex == "P" || item.sex == "IT") {
      kids.push(item)
    }
  })

  // checking hasil push yang duplicate
  // let obj = {};
  // let finalResult = cowok.filter((item) => {
  //   if (obj[item.US]) return false;
  //   obj[item.US] = true;
  //   return true;
  // })

  // let obj2 = {};
  // let finalResultCewek = cewek.filter((item) => {
  //   if (obj2[item.US]) return false;
  //   obj2[item.US] = true;
  //   return true;
  // })

  return {
    ...state,
    sizes: {
      ...state.sizes,
      maleSizes: { ...state.sizes.maleSizes, data: cowok, noDuplicate: cowok },
      femaleSizes: { ...state.sizes.femaleSizes, data: cewek, noDuplicate: cewek },
      apparelsSizes: apparels,
      kidsSizes: kids
    }
  }
}

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BRANDS: return handleGetAllBrands(state, action.payload)
    case GET_ALL_SIZES: return handleGetAllSizes(state, action.payload)
    default: return state
  }
}
export default filterReducer;
